/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Sd_Sendsemestermail2Inputs */

const en__field_sd_sendsemestermail2 = /** @type {(inputs: _Field_Sd_Sendsemestermail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatic invoice sending`)
};

const de__field_sd_sendsemestermail2 = /** @type {(inputs: _Field_Sd_Sendsemestermail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatischer Rechnungsversand`)
};

/**
* | output |
* | --- |
* | "Automatic invoice sending" |
*
* @param {_Field_Sd_Sendsemestermail2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_sd_sendsemestermail2 = /** @type {((inputs?: _Field_Sd_Sendsemestermail2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Sd_Sendsemestermail2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_sd_sendsemestermail2(inputs)
	return de__field_sd_sendsemestermail2(inputs)
});
export { _field_sd_sendsemestermail2 as "_field_sd_sendSemesterMail" }